import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

// Контроллер для автосохранения полей профиля при потере фокуса
// Использует существующие flash messages для уведомлений
export default class extends Controller {
  static targets = ["field"]
  static values = {
    url: String,
    delay: { type: Number, default: 500 }
  }

  connect() {
    this.timeout = null
    this.saving = false
    console.log('Profile autosave connected, URL:', this.urlValue)
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  // Автосохранение при потере фокуса (blur)
  autosave(event) {
    const field = event.currentTarget
    console.log('Autosave triggered for field:', field.name)

    // Проверяем валидность поля
    if (!field.checkValidity()) {
      console.log('Field is invalid, skipping autosave')
      return
    }

    this.saveField(field)
  }

  // Сохранение при нажатии Enter
  handleKeydown(event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      const field = event.target

      // Проверяем что это input или text field, а не textarea или button
      if (field.tagName === 'INPUT' && field.type !== 'checkbox' && field.type !== 'radio') {
        event.preventDefault()

        if (field.checkValidity()) {
          console.log('Enter pressed, saving field:', field.name)
          this.saveField(field)
        }
      }
    }
  }

  // Сохранение с задержкой (для select и других элементов)
  autosaveDelayed(event) {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    const field = event.currentTarget

    this.timeout = setTimeout(() => {
      if (field.checkValidity()) {
        this.saveField(field)
      }
    }, this.delayValue)
  }

  saveField(field) {
    if (this.saving) {
      console.log('Already saving, skipping')
      return
    }

    if (!this.urlValue) {
      console.error('Autosave URL not configured')
      return
    }

    this.saving = true
    console.log('Saving to:', this.urlValue)

    const formData = new FormData(this.element)

    patch(this.urlValue, {
      responseKind: "turbo-stream",
      body: formData
    }).then(response => {
      console.log('Autosave response:', response.ok ? 'success' : 'failed')
      if (!response.ok) {
        console.error('Autosave failed with status:', response.status)
      }
    }).catch(error => {
      console.error('Autosave error:', error)
    }).finally(() => {
      this.saving = false
    })
  }
}
